const base = {
  CONTRIBUTOR_API_PATH: '/api/v1',
  WORKSHOP_AWS_KEY: 'AKIAZFGJ6UVTYUVIKYWA',
  USER_UPLOAD_S3_BUCKET: 'measure-user'
};

const local = {
  CONTRIBUTOR_API_ENDPOINT: process.env.REACT_APP_C2_CONTRIBUTOR_API_ENDPOINT || "http://localhost:8001",
  WORKSHOP_API_ENDPOINT: process.env.REACT_APP_C2_WORKSHOP_API_ENDPOINT || "http://localhost:6007",
  TAXONOMY_API_ENDPOINT: process.env.REACT_APP_C2_TAXONOMY_API_ENDPOINT || "https://taxonomy.measureprotocol.com"
};

const dev1 = {
  CONTRIBUTOR_API_ENDPOINT: "http://contributor-dev-1.measureprotocol.com",
  WORKSHOP_API_ENDPOINT: "http://workshop-dev-1.measureprotocol.com",
  TAXONOMY_API_ENDPOINT: "http://taxonomy-dev-1.measureprotocol.com:6002"
};

const dev2 = {
  CONTRIBUTOR_API_ENDPOINT: "https://contributor-dev-2.measureprotocol.com",
  WORKSHOP_API_ENDPOINT: "https://workshop-dev-2.measureprotocol.com",
  TAXONOMY_API_ENDPOINT: "https://taxonomy-dev-2.measureprotocol.com"
};

const prod = {
  CONTRIBUTOR_API_ENDPOINT: "https://contributor.measureprotocol.com",
  WORKSHOP_API_ENDPOINT: "https://workshop.measureprotocol.com",
  TAXONOMY_API_ENDPOINT: "https://taxonomy.measureprotocol.com"
};

const configByEnv = {
  local: local,
  dev1: dev1,
  dev2: dev2,
  prod: prod
};

// merges the env config over the top of the base
export const config = Object.assign({}, base, configByEnv[process.env.REACT_APP_C2_ENV || 'local']);
